import apiClient from "./apiClient";

// ── Continuous Acceleration Report ───────────────────────────────────────

export const generateContinuousReport = async (payload) => {
  const response = await apiClient.post(`/master/commons/reporting/continuous-acceleration`, payload);
  return response.data;
};

export const exportContinuousReportExcel = async (payload) => {
  const response = await apiClient.post(`/master/commons/reporting/continuous-acceleration/export`, payload, {
    responseType: "blob",
  });
  return response.data;
};

// ── Student Level Report ─────────────────────────────────────────────────

export const generateStudentLevelReport = async (payload) => {
  const response = await apiClient.post(`/master/commons/reporting/student-level`, payload);
  return response.data;
};

export const exportStudentLevelReportExcel = async (payload) => {
  const response = await apiClient.post(`/master/commons/reporting/student-level/export`, payload, {
    responseType: "blob",
  });
  return response.data;
};

// ── QLR Report ───────────────────────────────────────────────────────────

export const generateQLRReport = async (payload) => {
  const response = await apiClient.post(`/master/commons/reporting/qlr`, payload);
  return response.data;
};

export const exportQLRReportExcel = async (payload) => {
  const response = await apiClient.post(`/master/commons/reporting/qlr/export`, payload, {
    responseType: "blob",
  });
  return response.data;
};
